/**
 * WONE-612: /signup/email-otp/code — signup OTP code-entry route.
 */

import React from "react";

import OtpCodeScreen from "./otp-code-screen";

const SignUpOtpCode: React.FC = () => <OtpCodeScreen purpose="signup" />;

export default SignUpOtpCode;
